import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

RouteGuardPassword.propTypes = {
  children: PropTypes.node,
};

export default function RouteGuardPassword({ children }) {
  const { user } = useAuth();
  const urlParams = new URLSearchParams(window.location.search);
  const tokenParam = urlParams.get('token');

  if (user) {
    if (user.password_reset) {
      return <Navigate to="/" />;
    } else {
      return <>{children}</>;
    }
  } else if (tokenParam) {
    return <>{children}</>;
  } else {
    return <Navigate to="/" />;
  }
}
